import { createContext } from 'react'

export type ToastVariant = 'info' | 'success' | 'warning' | 'error' | 'ghost'
export type ToastSeverity = 'normal' | 'critical'

export interface Toast {
  id: string
  message: string
  variant: ToastVariant
  severity?: ToastSeverity
  action?: { label: string; run: () => void }
  /** Optional override for transient action windows such as proposal undo. */
  durationMs?: number
}

export interface ToastContextValue {
  toasts: Toast[]
  paused: boolean
  focusModeActive: boolean
  /** Show a transient toast. Returns its id so callers can dismiss early. */
  showToast: (
    message: string,
    variant?: ToastVariant,
    action?: Toast['action'],
    severity?: ToastSeverity,
    options?: Pick<Toast, 'durationMs'>,
  ) => string
  dismissToast: (id: string) => void
  pauseToasts: () => void
  resumeToasts: () => void
  setFocusModeActive: (active: boolean) => void
}

export const ToastContext = createContext<ToastContextValue | undefined>(undefined)
